import React from 'react'
import clsx from 'clsx'
import {type TableTabsBaseProps} from '../TableTabs.tsx'
import styles from './HorizontalTabs.module.scss'

export const HorizontalTabs = ({className, activeTabId, tabs, onTabChange, size}: TableTabsBaseProps) => (
    <div className={clsx(styles.horizontalTabs, 'hide-scrollbar', className)}>
        {tabs.map((tab) => (
            <div
                key={tab.id}
                className={clsx(styles.tab, styles[size], 'm-no-drag', activeTabId == tab.id && styles.active)}
                onClick={() => onTabChange(tab.id)}
            >
                {tab.label}
            </div>
        ))}
    </div>
)
